module.exports = __webpack_public_path__ + "img/aerial-swimming-pool.704993b6.webp";